import { connectPagination } from 'instantsearch.js/es/connectors'
import { t } from '../../utils/search/translations'

const createPageLink = (createURL, klasses, pageNumber, linkText) => {
  return `<li class="ais-Pagination-item ais-Pagination-item--${klasses}">
    <a
      href="${createURL(pageNumber)}"
      data-value="${pageNumber}"
      aria-label="${pageNumber}"
      class="ais-Pagination-link"
    >${linkText}</a>
  </li>`
}

const renderFirstPageLink = (createURL) => {
  return createPageLink(createURL, 'firstPage hidden-xs', 0, t('pagination_first_page'))
}

const renderPreviousPageLink = (createURL, currentRefinement) => {
  return createPageLink(createURL, 'previousPage btn-antique-ghost', currentRefinement - 1, t('pagination_previous_page'))
}

const renderPageLink = (createURL, currentRefinement, page) => {
  const selectedClass = currentRefinement === page ? 'ais-Pagination-item--selected' : ''
  return createPageLink(createURL, `page hidden-xs ${selectedClass}`, page, page + 1)
}

const renderNextPageLink = (createURL, currentRefinement) => {
  return createPageLink(createURL, 'nextPage btn-antique-ghost', currentRefinement + 1, t('pagination_next_page'))
}

const renderLastPageLink = (createURL, nbPages) => {
  return createPageLink(createURL, 'lastPage hidden-xs', nbPages - 1, t('pagination_last_page'))
}

const setPaginationClickListeners = (container, refine) => {
  [...container.querySelectorAll('a')].forEach(element => {
    element.addEventListener('click', event => {
      event.preventDefault()
      document.body.scrollTop = document.documentElement.scrollTop = 0
      // The helper throws "Page requested below 0." on a negative page.
      refine(Math.max(0, parseInt(event.currentTarget.dataset.value, 10) || 0))
    })
  })
}

export const renderPagination = (renderOptions, _isFirstRender) => {
  const {
    pages,
    currentRefinement,
    nbPages,
    isFirstPage,
    isLastPage,
    refine,
    createURL
  } = renderOptions

  const container = document.querySelector('#pagination')
  if (!container) return

  // First render and empty results both have nbPages 0; the out-of-bounds
  // branch below would render a lone "Last" link to page -1.
  if (nbPages === 0) {
    container.innerHTML = ''
    return
  }

  if (currentRefinement >= nbPages) {
    // Page outside bounds / spider trap
    // Just render "Last" page link
    container.innerHTML = `<div class="ais-Pagination">
    <ul class="ais-Pagination-list">
      ${renderLastPageLink(createURL, nbPages)}
    </ul>
    </div>
    `
  } else {
    container.innerHTML = `<div class="ais-Pagination">
      <ul class="ais-Pagination-list">
        ${!isFirstPage
          ? `
            ${renderFirstPageLink(createURL)}
            ${renderPreviousPageLink(createURL, currentRefinement)}
            `
          : ''
        }

        ${pages.map(
            page => renderPageLink(createURL, currentRefinement, page)
          ).join('')
        }

        ${!isLastPage
          ? `
            ${renderNextPageLink(createURL, currentRefinement)}
            ${renderLastPageLink(createURL, nbPages)}
            `
          : ''
        }
      </ul>
      </div>
    `
  }

  setPaginationClickListeners(container, refine)
}

export const customPaginationWidget = connectPagination(
  renderPagination
)
